import React, { useState } from 'react';
import BotonBuscarChico from '../botones/BotonBuscarChico.js';
import PopupBuscarClub from '../../popups/PopupBuscarClub.js';
import CampoEditableTexto from '../campos/CampoEditableTexto.js';
import styles from './CampoBuscarClub.module.css';
import { PreFiltro } from '../../data/DataClubes.js';

const CampoBuscarClub = (props) => {
  const prefiltro = props.prefiltro;
  const objetoFiltro = props.objetoFiltro;
  const width = props.width;
  const editar = props.editar;
  const nombre = props.nombre;
  const club = props.valor;
  const paisDefault = props.pais;
  const [mostrarPopup, setMostrarPopup] = useState(false);
  const [nombreBuscar, setNombreBuscar] = useState('');

  const onCampoChange = (nombre, valor) => {
    setNombreBuscar(valor);
  };

  const onClubElegido = (club) => {
    props.onClubElegido(nombre, club);
    setMostrarPopup(false);
    setNombreBuscar(club.nombre);
  };

  const onClickBuscar = (event) => {
    event.preventDefault();
    setMostrarPopup(true);
  };

  const onCancelarPopup = () => {
    setMostrarPopup(false);
  };

  let htmlNombreClub = null;
  if (club) {
    let nombreClub = club.nombre;
    if (
      prefiltro &&
      prefiltro === PreFiltro.CLUB_RIVAL &&
      club.pais &&
      objetoFiltro.pais &&
      club.pais.id !== objetoFiltro.pais.id
    ) {
      nombreClub += ` (${club.pais.nombre})`;
    }
    htmlNombreClub = (
      <div className={`${styles.nombreClub}`} width={width}>
        {nombreClub}
      </div>
    );
  } else {
    htmlNombreClub = (
      <CampoEditableTexto
        nombre={nombre}
        valor={nombreBuscar}
        largo={50}
        editar={editar}
        width={width}
        onChange={onCampoChange}
        onPressEnter={onClickBuscar}
      />
    );
  }

  return (
    <div className={`${styles.contenedor}`}>
      {htmlNombreClub}
      <BotonBuscarChico estilo={`${styles.boton}`} onClick={onClickBuscar} />
      <PopupBuscarClub
        prefiltro={prefiltro}
        objetoFiltro={objetoFiltro}
        visible={mostrarPopup}
        texto={club ? club.nombre : nombreBuscar}
        pais={club ? club.pais : null}
        paisInicial={!club ? paisDefault : null}
        onClubElegido={onClubElegido}
        onCancelar={onCancelarPopup}
      />
    </div>
  );
};

export default CampoBuscarClub;
